import { createContext, Dispatch, SetStateAction } from 'react';
import { VodapayApi } from 'components/_global/vodapay';

export interface Vodapay {
  api?: VodapayApi;
  isActive: boolean;
  debug: (data: any) => void;
  authInit: () => void;
  paymentInit: (url: string) => void;
}

export interface VodapayEventListener {
  id: string;
  event: string;
  callback: (data: any) => void;
}

interface VodapayContextType {
  vodapay: Vodapay;
  setVodapayEventListeners: Dispatch<SetStateAction<VodapayEventListener[]>>;
}

export const defaultVodapayContext = {
  api: undefined,
  isActive: false,
  debug: (_data: any) => null,
  authInit: () => null,
  paymentInit: (_url: string) => null,
};

const defaultContext: VodapayContextType = {
  vodapay: defaultVodapayContext,
  setVodapayEventListeners: (
    _listener: SetStateAction<VodapayEventListener[]>
  ) => null,
};

const VodapayContext = createContext<VodapayContextType>(defaultContext);

export default VodapayContext;
